export enum ProjectTypes {
    Department = 1,
    Office = 2,
    House = 3,
    Plot = 4
}
